export const applyExclusiveOption = <T>(
  next: T[],
  current: T[],
  exclusiveOption: T
): T[] => {
  const justPickedExclusiveOption =
    !current.includes(exclusiveOption) && next.includes(exclusiveOption);

  return justPickedExclusiveOption
    ? [exclusiveOption]
    : next.filter(option => option !== exclusiveOption);
};

export const toSelectionLabels = <T>(
  values: T[] | null | undefined,
  describeValue: (value: T) => string,
  allLabel: string
): string[] =>
  values?.length ? values.map(value => describeValue(value)) : [allLabel];
